import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import { useLoader } from "../../components/Loader/LoaderProvider";
import { setUserData } from "../../utils/utils";
import { saveUserData } from "../../redux/Slices/auth";
import { isValidEmail, showError } from "../../utils/helper";
import { login } from "../../services/services";
import InputField from "../../components/InputField/InputField";
import { Image } from "react-bootstrap";

function Login() {
  const navigate = useNavigate();
  const [state, setState] = useState({
    isError: false,
    email: "",
    password: "",
  });
  const updateState = (data: any) => setState((prev) => ({ ...prev, ...data }));
  const { isError, email, password } = state;
  const loader = useLoader();
  const dispatch = useDispatch();

  const onSubmit = async (e: any) => {
    try {
      e?.preventDefault?.();
      if (!isValidEmail(email) || !password) {
        return updateState({ isError: true });
      }
      loader.show();
      const payload = {
        email: email,
        password: password,
      };
      const result: any = await login(payload);
      setUserData(result.data);
      dispatch(saveUserData(result.data));
      loader.hide();
      navigate("dashboard");
    } catch (error: any) {
      showError(error);
      loader.hide();
    }
  };

  return (
    <div
      className="d-flex align-items-center justify-content-center vh-100"
      style={{
        backgroundImage: "url('/images/background.jpg')",
        backgroundSize: "cover",
        backgroundPosition: "center",
      }}
    >
      <div
        className="bg-white rounded-4 shadow p-4"
        style={{
          maxWidth: "400px",
          width: "100%",
          background: "#FEFBF8",
        }}
      >
        <div className="text-center mb-3">
          <Image src="/images/logo.svg" className="login-logo" />
        </div>

        <form onSubmit={onSubmit}>
          <InputField
            type="email"
            placeholder="Email"
            value={email}
            onChange={(e) => {
              updateState({ email: e.target.value.trim() });
            }}
          />

          <InputField
            type="password"
            placeholder="Password"
            value={password}
            onChange={(e) => {
              updateState({ password: e.target.value.trim() });
            }}
          />

          {/* <div className="text-end mb-3">
            <a href="#" className="text-decoration-none small text-primary">
              Forgot password?
            </a>
          </div> */}

          <button
            type="submit"
            className="btn btn-dark w-100 mb-3"
            onClick={onSubmit}
          >
            Login
          </button>
        </form>
      </div>
    </div>
  );
}

export default Login;
